import { render, staticRenderFns } from "./product-list.html?vue&type=template&id=ff9fbfb8&scoped=true&external"
import script from "./product-list.js?vue&type=script&lang=js&external"
export * from "./product-list.js?vue&type=script&lang=js&external"
import style0 from "./product-list.scss?vue&type=style&index=0&id=ff9fbfb8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9fbfb8",
  null
  
)

export default component.exports